import { Footprints, Dumbbell, Medal, Brain, Eye, Network, Flame, Compass, Crown, Lock } from "lucide-react";

export const BADGE_ICONS = { footprints: Footprints, dumbbell: Dumbbell, medal: Medal, brain: Brain, eye: Eye, network: Network, flame: Flame, compass: Compass, crown: Crown };
const COLORS = ["bg-[var(--sun)]", "bg-[var(--mint)]", "bg-[var(--coral)]", "bg-sky-300", "bg-violet-300", "bg-lime-300", "bg-orange-300", "bg-cyan-300", "bg-amber-300"];

export const BadgeGrid = ({ badges }) => (
  <div className="grid grid-cols-2 gap-4 sm:grid-cols-3" data-testid="badge-grid">
    {badges.map((b, i) => {
      const Icon = b.earned ? BADGE_ICONS[b.icon] || Medal : Lock;
      return (
        <div key={b.id} data-testid={`badge-${b.id}`} data-earned={b.earned} className={`rise rounded-2xl border-2 border-[var(--ink)] p-4 text-center ${b.earned ? "ink-box-sm bg-white" : "bg-neutral-100 opacity-70"}`} style={{ animationDelay: `${i * 40}ms` }}>
          <span className={`mx-auto flex h-14 w-14 items-center justify-center rounded-full border-2 border-[var(--ink)] ${b.earned ? COLORS[i % COLORS.length] : "bg-white"}`}>
            <Icon className="h-6 w-6" strokeWidth={2.5} />
          </span>
          <p className="font-display mt-3 font-bold leading-tight">{b.title}</p>
          <p className="mt-1 text-xs font-semibold text-neutral-600">{b.description}</p>
          {!b.earned && (
            <div className="mt-3 h-2 overflow-hidden rounded-full border border-[var(--ink)] bg-white">
              <div className="h-full bg-[var(--sky)]" style={{ width: `${(b.progress / b.goal) * 100}%` }} />
            </div>
          )}
          <p className="mt-1 text-[11px] font-extrabold">{b.earned ? "Conquistato!" : `${b.progress}/${b.goal}`}</p>
        </div>
      );
    })}
  </div>
);
